import { render } from "./VerificationCode.vue?vue&type=template&id=535a5c39&scoped=true"
import script from "./VerificationCode.vue?vue&type=script&lang=js"
export * from "./VerificationCode.vue?vue&type=script&lang=js"

import "./VerificationCode.vue?vue&type=style&index=0&id=535a5c39&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535a5c39"]])

export default __exports__